import clsx from 'clsx'

// Mono telemetry readout strip (DESIGN.md §5.5). Latin/numeric only.
export function TelemetryStrip({ items, className }: { items: string[]; className?: string }) {
  return (
    <div className={clsx('telemetry mono', className)} aria-hidden>
      {items.map((it, i) => (
        <span key={i} className="telemetry-item">{it}</span>
      ))}
    </div>
  )
}
